import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=58db13cc&scoped=true"
import script from "./ChatRoom.vue?vue&type=script&lang=ts"
export * from "./ChatRoom.vue?vue&type=script&lang=ts"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=58db13cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db13cc",
  null
  
)

export default component.exports